// @ts-nocheck
import React from 'react';

import Tab from './Tab';
import TabsContextProvider from './Tabs.context';
import { TabsStyled } from './Tabs.style';

import type { PropsWithChildren } from 'react';

type Props = {
  defaultTabId: string;
  onTabClick?: (id: any) => void;
};

function Tabs({ children, defaultTabId, onTabClick }: PropsWithChildren<Props>) {
  return (
    <TabsContextProvider defaultTabId={defaultTabId} onTabClick={onTabClick}>
      <TabsStyled>{children}</TabsStyled>
    </TabsContextProvider>
  );
}

Tabs.Item = Tab;

export default Tabs;
